import {
    ACTION_GET_ICONS,
    SET_ICONS,
} from "@/shared/components/icons_selector/store/types/types.js";

import config from "@/shared/components/icons_selector/config/change_image_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

const actions = {
    
    [ACTION_GET_ICONS]: async ({ state, commit }) => {
        
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/get/images/Categoria`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        
                        const icons = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogIcons: false,
                            index: i
                        }));
                        
                        commit(SET_ICONS, icons);
                        resolve(resp.data);
                    } else {
                        reject("La respuesta no tiene un formato esperado");
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                reject(error);
            }
        });
    },
}
export default actions;